<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->
<div mat-dialog-container>
  <div mat-dialog-title>
    Select Injects to Add
    &nbsp;
    <button
      mat-icon-button
      (click)="handleEditComplete(false)"
      title="Cancel"
      class="close-button"
      tabindex="-1"
      >
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (!!data && data.catalog) {
    <div mat-dialog-content>
      <app-inject-list
        [catalog]="data.catalog"
        [injectType]="data.injectType"
        [injectList]="data.injectList"
        [isContentDeveloper]="false"
        [loggedInUserId]="data.loggedInUserId"
        (selectedInjectIdList)="selectedInjectIdList=$event"
      ></app-inject-list>
    </div>
  }
  <div mat-dialog-actions>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="!errorFree()" style="margin-left: 40px;">Add</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
